import React, { useState } from 'react';
import { Navbar as BSNavbar, Container, Dropdown, Nav } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { navItems } from './Sidebar';
import { DEMO_CONFIG, isDemoMode } from '../utils/demo';

function Navbar({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const isActive = (path) => location.pathname === path;

  const closeMenu = () => {
    setExpanded(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setExpanded(false);
    navigate('/login');
  };

  return (
    <BSNavbar
      bg="white"
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      className="topbar border-bottom sticky-top"
    >
      <Container fluid>
        <BSNavbar.Brand as={Link} to="/" onClick={closeMenu}>
          民泊管理
        </BSNavbar.Brand>
        <BSNavbar.Toggle aria-controls="main-navbar-nav" />
        <BSNavbar.Collapse id="main-navbar-nav" className="justify-content-end">
          <Nav className="mobile-nav-links">
            {navItems.map((item) => (
              <Nav.Link
                key={item.path}
                as={Link}
                to={item.path}
                onClick={closeMenu}
                className={isActive(item.path) ? 'active' : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                <span>{item.label}</span>
              </Nav.Link>
            ))}
          </Nav>

          {isDemoMode() && (
            <Nav.Link
              href={DEMO_CONFIG.contactUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="me-2 fw-semibold"
            >
              お問い合わせ
            </Nav.Link>
          )}

          <Dropdown align="end" className="user-dropdown">
            <Dropdown.Toggle variant="outline-primary" id="user-menu">
              {isDemoMode() ? 'デモユーザー' : 'ユーザー'}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="/settings" onClick={closeMenu}>設定</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout}>ログアウト</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
}

export default Navbar;
